import moment from "moment";

export const START_NUMBER = "startNumber";
export const END_NUMBER = "endNumber";
export const RANGE_DESCRIPTION = "description";
export const WARNING_PERCENTAGE = "warningThresholdPercent";
export const ACTIVATE_IMMEDIATELY = "activateImmediately";

export const formatRangeNumber = (value: any) => {
  if (value === 0) return "0";
  if (value === null || value === undefined || value === "") return "—";
  const num = Number(String(value).replace(/,/g, ""));
  return Number.isNaN(num) ? String(value) : num.toLocaleString("en-US");
};

export const formatDateTime = (value: any) => {
  if (!value) return "—";
  const parsed = moment(value);
  return parsed.isValid() ? parsed.format("MM/DD/YYYY h:mm A") : "—";
};

export const isRangeActive = (range: any) => {
  const status = String(range?.status || "").toUpperCase();
  if (status) return status === "ACTIVE";
  return range?.active !== false;
};